import {FC} from "react";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {getUserAchievements, getUserEarnedAchievements} from "modules/selectors";
import {StatItem} from "./StatItem";
import {isNumber} from "lodash";

const Wrapper = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	gap: 12px;

	@media (min-width: 769px) {
		justify-content: flex-end;
	}
`;

const getValue = (value: number | null) => (isNumber(value) ? value : "-");

const getUserBadgesView = (userEarnedAchievements: number, userAchievements: number) => {
	if (!userEarnedAchievements) {
		return "-";
	}

	return `${getValue(userEarnedAchievements)}/${getValue(userAchievements)}`;
};

export const PlayerStats: FC = () => {
	const {t} = useTranslation();
	const userAchievements = useSelector(getUserAchievements);
	const userEarnedAchievements = useSelector(getUserEarnedAchievements);

	return (
		<Wrapper>
			<StatItem
				value={getUserBadgesView(userEarnedAchievements.length, userAchievements.length)}
				name={t("game_bar.stats.badges")}
			/>
		</Wrapper>
	);
};
